import React from 'react'
import classes from './Financials.module.css'
import SubSectionHeader from '../../Shared/SubSectionHeader'
import { Card } from 'react-bootstrap'
import NotAvailable from '../NotAvailable'

const Financials = ({Financials=[]}) => {
  const FinanceCard=({finance,index})=>{
    return <Card className={classes['FinanceCard']}>
      <div className={classes['Label']}>
                {finance.label}
            </div>
            <div className={classes['Value']}>
            {finance.value}
            </div>
          </Card>
  }
    return (
      <div className={classes['Container']}>
        <SubSectionHeader title="Financials" className={classes['title']}></SubSectionHeader>
        <div className={classes['Master']}>
          {
            Financials.length > 0 ?
              <div className={classes['FinancialsContainer']}>
                {
                  Financials.map((item, index) => <FinanceCard finance={item} index={index} />)
                }
              </div>
              :
              <NotAvailable />

          }
        </div>
      </div>
    )
}



export default Financials
